import React from 'react';
import PropTypes from 'prop-types';

import { colors } from '@styleseat/brand';
import { Button } from '../../ui';

/**
 * Link-styled button, all caps, underlined, small
 */
export const LearnMoreLink = props => (
  <Button
    appearance="link"
    style={{
      color: colors.blackInBlack,
      fontSize: 12,
      fontWeight: 500,
      borderBottom: `2px solid ${colors.blackInBlack}`,
      textDecoration: 'none',
      padding: 2,
      margin: 0,
      height: 24,
      lineHeight: '24px',
    }}
    {...props}
  >
    {props.children}
  </Button>
);
LearnMoreLink.propTypes = {
  children: PropTypes.node,
};
LearnMoreLink.defaultProps = {
  children: null,
};
export default LearnMoreLink;
